function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
export var ScrollDirectionX;
(function (ScrollDirectionX) {
  ScrollDirectionX[ScrollDirectionX["Left"] = -1] = "Left";
  ScrollDirectionX[ScrollDirectionX["None"] = 0] = "None";
  ScrollDirectionX[ScrollDirectionX["Right"] = 1] = "Right";
})(ScrollDirectionX || (ScrollDirectionX = {}));
export var ScrollDirectionY;
(function (ScrollDirectionY) {
  ScrollDirectionY[ScrollDirectionY["Up"] = -1] = "Up";
  ScrollDirectionY[ScrollDirectionY["None"] = 0] = "None";
  ScrollDirectionY[ScrollDirectionY["Down"] = 1] = "Down";
})(ScrollDirectionY || (ScrollDirectionY = {}));
// A psuedo element is used to calculate heightCollapsedControls as the window.height value changes
// on iOS as the user scrolls and the browser chrome shrinks
let vhElement;
// State
let state;
/**
 * Gets the current state of the viewport
 * @returns ViewportDetails
 */
export function getViewportDetails() {
  setDetails();
  return state;
}
/**
 * Updates the details
 */
function setDetails() {
  let previous;
  if (state) {
    previous = _objectSpread({}, state);
    delete previous.previous;
    delete previous.changed;
  } else {
    vhElement = addHeightElement();
  }
  // Get current
  const width = window.innerWidth;
  const height = window.innerHeight;
  const heightCollapsedControls = vhElement.offsetHeight;
  const scrollX = window.pageXOffset;
  const scrollY = window.pageYOffset;
  const resized = previous ? previous.width !== width || previous.height !== height : false;
  const scrolled = previous ? previous.scrollX !== scrollX || previous.scrollY !== scrollY : false;
  state = {
    width,
    height,
    heightCollapsedControls,
    scrollX,
    scrollY,
    scrollDirectionX: previous ? getScrollDirection(previous.scrollX, scrollX) : ScrollDirectionX.None,
    scrollDirectionY: previous ? getScrollDirection(previous.scrollY, scrollY) : ScrollDirectionY.None,
    resized,
    scrolled,
    changed: resized || scrolled,
    previous
  };
}
/**
 * Adds a HTML element to the view that is the exact same height as the viewport. This is used for calculating the height of the element if
 * the viewport controls were collapsed
 * @returns HTMLElement
 */
function addHeightElement() {
  const id = 'viewport-details-height-element';
  let element = document.getElementById(id);
  if (!element) {
    element = document.createElement('div');
    element.id = id;
    element.style.position = 'fixed';
    element.style.height = '100vh';
    document.documentElement.appendChild(element);
  }
  return element;
}
/**
 * Gets the direction in which the user is scrolling
 */
function getScrollDirection(previous, current) {
  if (previous < current) {
    return 1;
  }
  if (previous > current) {
    return -1;
  }
  return 0;
}